import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {YoutubeService} from "../../../services/youtubeService/youtube.service";
import {appInjector} from "../../appInjector";

export class VideoPin extends AbstractMainPlugin {

  private videoInput = null;
  private videoInputHash = null;
  private yt:YoutubeService;
  // private currentTool;

  static getBeforeItemComponents() {
    return [];
  }

  constructor(item:Item) {
    super(item);

    if (!this.hasVideoPin()){
      return;
    }
    this.yt = appInjector.get(YoutubeService);
    this.videoInput = this.item.config.getInputByName('youtube_video_url');
    this.videoInputHash = JSON.stringify(this.videoInput);
    this.initListeners();
  }

  private hasVideoPin(){
    console.log('this.item.config.getInputByName', this.item.config.getInputs());
    return this.item.config.getInputByName('youtube_video_url') || null;
  }

  initListeners(){
    this.item.config.subject.subscribe((newConfig)=>{
      this.processUpdate(newConfig);
    });

    this.item.getSubject(Item.OBJECT_CLICK).subscribe((isCtrl)=>{
      if (!isCtrl){
        if (this.videoInput.value && this.videoInput.value.trim().length > 0)
        this.yt.openModal(this.videoInput.value);
      }
    })

  }

  private processUpdate(newConfig){
    let newInput = newConfig.getInputByName('youtube_video_url');
    let newHash = JSON.stringify(newInput);
    if (newHash!=this.videoInputHash){
      this.videoInputHash = newHash;
    }
  }

}
